<template>
    <ModeSwitcher
        ref="modeSwitcher"
        :edit-mode-text="`${$t('edit')} ${selectedPSP?.provider?.name}`"
        edit-mode-only
        class="pt-4"
    >
        <template v-slot:main-mode>
            <v-data-table
                :headers="headers"
                :items="settings"
                :loading="isLoading"
                disable-sort
                density="compact"
                class="elevation-1 table-server mb-2"
                :items-per-page="-1"
                hide-default-footer
            >
                <template v-slot:item.provider="{item}">
                    <span class="text-link" @click="editPSP(item)">{{ item.provider.name }}</span>
                </template>
                <template v-slot:item.singleCredential="{item}">
                    {{ item.singleCredential ? $t('one_account') : $t('multiple_accounts') }}
                </template>
            </v-data-table>
        </template>
        <template v-slot:additional-mode>
            <OnlinePaymentsForm
                v-if="selectedPSP"
                :selected-p-s-p="selectedPSP"
                @save="save()"
                @cancel="modeSwitcher.goToTable()"
            />
        </template>
    </ModeSwitcher>
</template>
<script setup lang="ts">
    const isLoading = ref<boolean>(false)
    const settings = ref([])
    const modeSwitcher = ref(null)
    const selectedPSP = ref(null)

    const {$api, $toast} = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        await loadData()
        EventBus.$on(CHANGE_LOCALE_EVENT, loadData)
    })

    onBeforeUnmount(async () => {
        EventBus.$off(CHANGE_LOCALE_EVENT, loadData)
    })

    async function loadData(): Promise<void> {
        isLoading.value = true
        try {
            const {pspSettings} = await $api.pspSettings.get()
            settings.value = pspSettings
        } catch (e) {
            $toast.error(t('error_message.load_error'))
        } finally {
            isLoading.value = false
        }
    }

    const headers = computed(() => {
        return [
            {title: t('name'), value: 'provider', minWidth: '120px'},
            {title: t('markup_percent'), value: 'markup'},
            {title: t('base_currency_for_conversion'), value: 'baseCurrency'},
            {title: t('account'), value: 'singleCredential'},
        ]
    })

    const editPSP = (psp): void => {
        modeSwitcher.value.edit()
        selectedPSP.value = psp
    }

    const save = async (): Promise<void> => {
        await loadData()
    }
</script>
